<template>
  <BRow>
    <BCol cols="3">
      <p class="font-weight-bolder text-center">نام کاربر</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder text-center">نسبت کاربر</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder text-center">تصویر</p>
    </BCol>
    <BCol cols="3">
      <p class="font-weight-bolder text-center">جزئیات</p>
    </BCol>
    <BCol cols="12" class="mt-0 px-0">
      <hr class="mt-0" />
    </BCol>
    <template v-if="userFamilyList && userFamilyList.length">
      <BCol
        cols="12"
        v-for="(user, index) in userFamilyList"
        :key="user.userFamilyId"
      >
        <BRow
          class="custom-inner-table-bg-color rounded-sm py-1"
          align-v="center"
        >
          <BCol cols="3" class="px-2 mx-auto text-center">
            <b-link :to="`/users/${user.userFamilyId}`">
              {{ user.fullName }}
            </b-link>
          </BCol>
          <BCol cols="3" class="px-2 mx-auto text-center">
            {{ familyTypes[user.familyType] }}
          </BCol>
          <BCol cols="3" class="px-2 mx-auto text-center">
            <template v-if="user.userFamilyDocument">
              <BImg
                style="max-height: 10rem; max-width: 80%"
                :src="`${baseUrl}/${user.userFamilyDocument}`"
                height="300"
              ></BImg>
            </template>
            <template v-else> - </template>
          </BCol>
          <BCol cols="3" class="px-2 mx-auto text-center">
            <BButton
              size="sm"
              :variant="user.isVerified ? 'danger' : 'success'"
              @click="renderToggleUserFamilyConfirmationDialog(user)"
            >
              {{ user.isVerified ? "عدم تایید" : "تایید" }}
            </BButton>
          </BCol>
        </BRow>
      </BCol>
    </template>
    <ToggleUserFamilyVerifyConfirmationDialog
      :tempSelectedUserFamily="tempSelectedUserFamily"
      :selectedUserId="selectedUserId"
      @refetch="refetch"
    ></ToggleUserFamilyVerifyConfirmationDialog>
  </BRow>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    userFamilyList: {
      type: Array,
    },
    selectedUserId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      familyTypes: {
        1: "پدر",
        2: "مادر",
        3: "خواهر",
        4: "برادر",
        5: "دوست",
      },
      tempSelectedUserFamily: null,
    };
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderToggleUserFamilyConfirmationDialog(selectedUserFamily) {
      this.tempSelectedUserFamily = selectedUserFamily;
      this.$nextTick(() => {
        this.$bvModal.show(
          `toggle-user-family-verify-dialog-${this.tempSelectedUserFamily.familyUserId}`
        );
      });
    },
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    ToggleUserFamilyVerifyConfirmationDialog,
    BRow,
    BCol,
    BImg,
    BButton,
    BLink,
  },
};
import ToggleUserFamilyVerifyConfirmationDialog from "@/views/components/Shared/ToggleUserFamilyVerifyConfirmationDialog.vue";
import { BRow, BCol, BImg, BButton, BLink } from "bootstrap-vue";
</script>
